import { render, staticRenderFns } from "./alchemist.html?vue&type=template&id=ed7b040e&"
import script from "./alchemist.js?vue&type=script&lang=js&"
export * from "./alchemist.js?vue&type=script&lang=js&"
import style0 from "./alchemist.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports